import Link from 'next/link'

import HeroLogo from 'components/icons/HairoLogo'

const TrustedPartnershipBanner = () => {
  return (
    <div className='d-flex flex-column mt-4 mt-md-0 partnership-banner'>
      <HeroLogo
        className='hero-banner-logo align-self-start align-self-lg-center'
        height='78'
        width='78'
      />
      {/*fs is always 20*/}
      <div className='fs-20 mt-2 fw-semibold'>
        Trusted partnerships with financial institutions to reach over 100,000
        customers to date.
      </div>
    </div>
  )
}

export default TrustedPartnershipBanner
